import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params } from '@angular/router';
import {PasswordReset} from './passwordReset';
import {AppConfig} from '../../../app.config';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  templateUrl: 'reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {

  private resetKey;
  public model: PasswordReset;
  private _errorMessage: string;
  private _infoMessage: string;
  public _successful: boolean;


  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {

    this.model = new PasswordReset();

    this.route.queryParams.subscribe((params: Params) => {
      this.resetKey = params['key'];
    });
  }

  submit(): boolean {

    this._errorMessage = '';
    this._infoMessage = '';

    if (!this.validatePasswords()) {
      return false;
    }

    const body = {
      key: this.resetKey,
      newPassword: this.model.newPassword
    };


    this.authService.post(AppConfig.UAA_URL + '/api/account/reset-password/finish',
      JSON.stringify(body)).subscribe({
        next: (value) => {
          this._infoMessage = 'Password reset successful.';
          this._errorMessage = '';
          this._successful = true;
        },
        error: (error) => {
          this._infoMessage = '';
          this._errorMessage = 'Could not reset password. Make sure that you\'ve submitted this request only once. ' +
            'If that doesn\'t help, go back to password reset request page and click again on link sent to you via email.';
        }
      });


  }

  private validatePasswords(): boolean {

    if (!this.model.newPassword) {
      this._errorMessage = 'Please enter password.';
      return false;
    }

    if (this.model.newPassword !== this.model.confirmPassword) {
      this._errorMessage = 'Please make sure that passwords do match.';
      return false;
    }

    return true;
  }

  get errorMessage(): string {
    return this._errorMessage;
  }

  get infoMessage(): string {
    return this._infoMessage;
  }

}
